import ComponentEvents from 'components/component-events';
import LayoutScroll from 'components/layout-scroll';

function Layout(options = {}) {
    // наследование
    ComponentEvents.call(this, options);

    this.scroll = new LayoutScroll();
}

// наследование
Layout.prototype = Object.create(ComponentEvents.prototype);

// цепочка прототипов
Object.defineProperty(Layout.prototype, 'constructor', {
    value: Layout,
    writable: true,
    enumerable: false,
});

// singleton
if (typeof window.Layout == 'undefined') {
    window.Layout = new Layout();
}

export default window.Layout;
